import { useModalManager } from '@healthhub/react-ui';
import type { SerializedError } from '@reduxjs/toolkit';
import { useState } from 'react';

import useInvisibleCaptcha from '@shared/hooks/useInvisibleCaptcha';
import { useLazyGetReCaptchaQuery } from '@shared/services/validateCaptcha';

import { handleNewsLetterSubscriptionWithNewTab } from '../utils';

export const useNewsLetterSubscription = () => {
  const { showErrorModal } = useModalManager();
  const [getReCaptchaData] = useLazyGetReCaptchaQuery();
  const { getToken, turnstileWidget, captchaProvider } = useInvisibleCaptcha();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const subscribeToNewsLetter = async (email: string, onFinally?: () => void) => {
    setIsSubmitting(true);

    await handleNewsLetterSubscriptionWithNewTab({
      getToken,
      email,
      onValidate: async (token) => !!(await getReCaptchaData({ ResponseToken: token, Version: 'v3' }).unwrap()),
      onError: (err) => {
        const error = err as SerializedError;
        showErrorModal({
          errorCode: error?.code,
        });
      },
      onFinally: () => {
        setIsSubmitting(false);
        onFinally?.();
      },
    });
  };

  return { subscribeToNewsLetter, isSubmitting, turnstileWidget, captchaProvider };
};
